// src/pages/GuestCenter.jsx
import React, { useState } from 'react';
import GuestTable from '../components/GuestTable';
import useGuestData from '../hooks/useGuestData';
import { TextField, Box, Typography } from '@mui/material';

export default function GuestCenter() {
  const [search, setSearch] = useState('');
  const propertyData = JSON.parse(localStorage.getItem('user'));
  const propertyId = propertyData?.propertyId?.id || null;
  const { guests, loading } = useGuestData(search, propertyId);
  console.log('[GuestCenter] Debug:', { guests, loading, propertyId });

  return (
    <Box sx={{ padding: 4 }}>
      <Typography variant="h6" fontWeight={500} gutterBottom>
        Guest Information Center
      </Typography>

      <Box
        sx={{
          mt: 2,
          mb: 3,
          border: '1px solid #ccc',
          borderRadius: '12px',
          px: 1.5,
          py: 0.5,
          maxWidth: 400,
        }}
      >
        <input
          type="text"
          placeholder="Search by guest name, email or phone"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          style={{
            width: '100%',
            border: 'none',
            outline: 'none',
            fontSize: '14px',
            backgroundColor: 'transparent',
          }}
        />
      </Box>

      <GuestTable guests={guests} loading={loading} />
    </Box>
  );
}